import { render, staticRenderFns } from "./ArticleListItem.vue?vue&type=template&id=2acf112a&scoped=true"
import script from "./ArticleListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ArticleListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ArticleListItem.vue?vue&type=style&index=0&id=2acf112a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf112a",
  null
  
)

export default component.exports